import { useQuery } from 'react-query';

import { getSubProgramPreferenceImportance as queryFn } from 'api/endPoints/getSubProgramPreferenceImportance';

interface IGetSubProgramPreferenceImportanceResponse {
    defaultCriticalPathSetting: boolean;
    defaultTopCriticalityPercent: number;
    defaultCompletionPercent: number;
}

export const useQueryGetSubProgramPreferenceImportance = ({ subProgramId }) => {
    return useQuery<IGetSubProgramPreferenceImportanceResponse, QueryError>(
        ['getSubProgramPreferenceImportance', subProgramId],
        () => queryFn({ subProgramId }),
        {
            enabled: Boolean(subProgramId),
        },
    );
};
